var exports = {
  "I6": "inputWrapper__jNYz-A",
  "mK": "imageAttachments___zvm-8",
  "uZ": "composerMinHeight__y_ZVW4",
  "jY": "isDraggedOver__mpXRNs",
  "cd": "autocompleteWrapper__7gQdo-",
  "Nx": "composerNewConversationMinHeight__0z0Dk2",
};

module.exports = exports;
